import AdminCancelledEventsList from "./cancelledEvents";

export default AdminCancelledEventsList;
